import React from 'react'
import ItemView from '../../common/ItemView'
import { ItemContainer, Title } from '~/app/components/order-list/common/OrderDetailsCommonStyled'

/**
 * RoomInformation component
 * author: soojin.oh
 */

// type definitions
type RoomInformationProps = {
  id?: string
  roomName?: string
  capacity?: string
  bed?: string
  smoking?: string
}

// styled components

// RoomInformation component
const RoomInformation: React.FunctionComponent<RoomInformationProps> = function ({
  id,
  roomName,
  capacity,
  // bed,
  smoking,
}) {
  return (
    <ItemContainer id={id}>
      <Title>객실정보</Title>
      <ItemView title={'객실 이름'} description={roomName} />
      <ItemView title={'인원'} description={capacity} />
      {/*<ItemView title={'침대 구성'} description={bed} />*/}
      <ItemView title={'흡연 여부'} description={smoking} />
    </ItemContainer>
  )
}

export default RoomInformation
